import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ViewProperties } from "../ViewProperties";
export class ImageTaggedTextProperties extends ViewProperties {
    constructor() {
        super(...arguments);
        this.trimWhiteSpace = true;
        this.alignment = ControlConstants.CENTER;
    }
    equals(other) {
        return false;
    }
}
//# sourceMappingURL=ImageTaggedTextProperties.js.map